<div class="lm-reports-list-wrapper" [ngClass]="{'in-modal': (uniqueId === 'reportSecurity')}">
  <!-- SOHO DATAGRID -->
  <div [ngClass]="{'lm-reports-content-wrapper': true}">
    <div class="lm-reports-datagrid-wrapper">
      @if (reportsArray) {
        <div class="scrollable-flex-content" style="margin-top: 5px;"
          data-automation-id="lm-reports-catalog-datagrid"
          soho-datagrid  #columnDataGridComponent
          [attr.id]="columnDataGridComponent"
          [gridOptions]="columnGridOptions"
          (cellchange)="onPropertiesChange($event)">
        </div>
      }
    </div>
  </div>
</div>
